/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import proptypes from 'prop-types';
const { string, func, number } = proptypes;
import { extend, useDataModel } from '@thd-nucleus/data-sources';
import { Price } from '@thd-olt-component-react/price';
import { SuperSkuMiniSwatches, SuperSku } from '@thd-olt-component-react/super-sku';
import { AddTo, AddToListModel } from '@thd-olt-component-react/add-to';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import { FulfillmentPodShipping, FulfillmentPodStore } from '@thd-olt-component-react/fulfillment';
import { Quantity } from '@thd-olt-component-react/quantity';
import {
  ProductPod,
  PodSticker,
  PodSection,
  ProductATC,
  ProductLink,
  ProductRating,
  ProductImage,
  ProductIdentifier,
  ProductCompare,
  ProductSample,
  ProductBadge,
  ProductSponsored,
  PodSpacer,
  ProductPodPlaceholder
} from '@thd-olt-component-react/product-pod';

export const ListViewPod = ({
  itemId,
  parent,
  position,
  storeId
}) => {
  const { data, loading } = useDataModel('product', { variables: { itemId } });
  if (!data || loading) {
    return (
      <ProductPodPlaceholder podsCount={1} podType="list" />
    );
  }

  return (
    <div className="sui-border-b-1 sui-border-solid sui-border-primary">
      <ProductPod
        key={'3-' + itemId}
        itemId={itemId}
        hasSSKU
        analyticsData={{
          parent, position
        }}
        render={(pod) => (
          <PodSection margin>
            <div className="sui-w-full sui-flex sui-flex-wrap sm:sui-flex-nowrap">
              <div className="sui-w-full lg:sui-w-3/12">
                <PodSection noPadding columnAlign relative>
                  <PodSticker position="top-left">
                    <ProductBadge itemId={pod.itemId} />
                  </PodSticker>
                  <PodSticker position="top-right">
                    <PodSpacer padding={['TOP', 'RIGHT']}>
                      <AddTo
                        addToType="List"
                        products={[
                          {
                            itemId: pod.itemId,
                            quantity: pod.quantity
                          }
                        ]}
                        list={{ showCount: true, showIconButton: true }}
                      />
                    </PodSpacer>
                  </PodSticker>
                  <ProductImage
                    itemId={pod.itemId}
                    showSecondaryImage={pod.showSecondaryImage}
                  />
                </PodSection>
              </div>
              <div className="sui-pl-4 sui-w-full lg:sui-w-5/12">
                <PodSpacer padding={['TOP', 'BOTTOM']}>
                  <ProductHeader
                    brand="hidden"
                    itemId={pod.itemId}
                    brandTitleMaxLine={4}
                    disableShopThisCollection
                  />
                </PodSpacer>
                <PodSpacer padding={['TOP', 'BOTTOM']}>
                  <SuperSku
                    itemId={pod.itemId}
                    storeId={storeId}
                    onChange={pod.onChange}
                    onHover={pod.onSSKUHover}
                    numberOfMiniSwatches={5}
                  />
                </PodSpacer>
                <PodSpacer padding={['TOP']}>
                  <KeyProductFeatures
                    hideImage
                    storeId={pod.storeId}
                    itemId={pod.itemId}
                    maxfeatures={3}
                    simple
                    oneColumnGrid
                  />
                </PodSpacer>
              </div>

              <div className="sui-w-full lg:sui-w-4/12 sui-p-3">
                <ProductRating itemId={pod.itemId} />
                <Price
                  itemId={pod.itemId}
                  type="simple"
                  displayEachUom={false}
                  storeId={storeId}
                  hideBadge
                  hideLimitPerOrder
                  hideBulkPrice
                />
                <PodSpacer minHeight="45px" padding={['TOP', 'BOTTOM']}>
                  <FulfillmentPodStore itemId={pod.itemId} storeId={pod.storeId} />
                  <FulfillmentPodShipping itemId={pod.itemId} storeId={pod.storeId} />
                </PodSpacer>
                <div className="sui-flex sui-flex-col xl:sui-flex-row sui-gap-2 xl:sui-items-center">
                  <div className="xl:sui-w-1/2 -sui-mt-1">
                    <Quantity 
                      itemId={pod.itemId}
                      onChange={pod.onQuantityUpdate}
                      textOnly
                      wideView
                      hideIfATCDisabled
                    />
                  </div>
                  <div className="xl:sui-w-1/2 sui-mt-1">
                    <ProductATC
                      itemId={pod.itemId}
                      outline
                      showDisabledATC
                      doNotShowChooseYourOptions
                    />
                  </div>
                </div>
                <ProductLink
                  itemId={pod.itemId}
                  text="See Full Details"
                />
              </div>
            </div>
          </PodSection>
        )}
      />
    </div>
  );
};

ListViewPod.dataModel = extend(
  ProductPod,
  AddToListModel,
  ProductImage,
  Price,
  SuperSku,
  SuperSkuMiniSwatches,
  ProductATC,
  ProductRating,
  ProductCompare,
  ProductSample,
  ProductIdentifier,
  ProductHeader,
  ProductBadge,
  ProductSponsored,
  FulfillmentPodStore,
  FulfillmentPodShipping,
  KeyProductFeatures
);

ListViewPod.propTypes = {
  itemId: string.isRequired,
  storeId: string.isRequired,
  parent: string.isRequired,
  position: number.isRequired
};

ListViewPod.defaultProps = {};

ListViewPod.displayName = 'ListViewPod';
